import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { getHelpDeskListViews } from '../../handler/HelpDeskViewHandler';

export const DialogNoticeViewChanged = props => {
    const {
        API,
        setIsInitView,
        setViewSelected,
        setViewStructure,
        setListView,
        userDetail,
        setIsOpenDialogViewChanged,
        setIsLoading,
        isOpenDialogViewChanged,
        projectInuseDetail,
        viewStructure,
        corporationId,
        setDefaultDrillDownData
    } = props;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        setIsOpenDialogViewChanged(false);
    };

    const onClickOkButton = async () => {
        setIsLoading(true);
        setIsOpenDialogViewChanged(false);

        const getDefaultDrilldownParams = {
            corporationId,
            setDefaultDrillDownData
        }
        await getHelpDeskListViews(
            API, 
            setIsInitView, 
            setViewSelected, 
            setViewStructure, 
            setListView, 
            userDetail.id,
            projectInuseDetail.id,
            viewStructure.visibility,
            Constant.DEFINITION_VIEW.HELPDESK,
            getDefaultDrilldownParams
        );
        setIsLoading(false);
    };

    return (
        <Dialog
            open={isOpenDialogViewChanged}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    データが変更されました。ページを更新してください。
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={onClickOkButton}
                >
                    {I18n.get('COMBTN002')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
